import store from '@/store'
import { CompleteRegistrationDestinationType } from '@/common/enums'
import { ProspectModel } from '@/models/prospect'
import { getRegistrationRedirect, isNewRegistrationFlow } from '@/utils/registrationFlow'

const PENDING_ROUTE_KEY = 'pendingRouteAfterAuth'

const isAuthorized = (to, from, next) => {
  if (store.getters['auth/isAuthorised']) {
    next()
  } else {
    // Remember the target route so the user returns to it after sign-in (P5),
    // e.g. after tapping a push notification with an expired session.
    try {
      if (to.fullPath && to.fullPath !== '/sign-in') {
        localStorage.setItem(PENDING_ROUTE_KEY, to.fullPath)
      }
    } catch (e) {
      // ignore storage errors
    }
    next('/sign-in')
  }
}

const registrationRequired = (to, from, next) => {
  const redirect = getRegistrationRedirect(store.getters['user/user'])
  if (redirect && redirect.name !== to.name) {
    next(redirect)
  } else {
    next()
  }
}

const registrationNotRequired = (to, from, next) => {
  const user = ProspectModel.parseFromApi({ prospect: store.getters['user/user'] })
  if (!user.requireRegistration) {
    const redirect = getRegistrationRedirect(user)
    next(redirect || { name: 'Dashboard' })
  } else {
    next()
  }
}

// The optional profile-details page (LL-169) is only reachable by a new-flow
// participant who has a selfie and has not dismissed it yet. Any other state is
// sent to the next outstanding checkpoint or the dashboard.
const registrationDetailsRequired = (to, from, next) => {
  const user = ProspectModel.parseFromApi({ prospect: store.getters['user/user'] })
  if (
    !user.requireRegistration &&
    isNewRegistrationFlow(user) &&
    user.image &&
    !user.registrationDetailsDismissed
  ) {
    next()
  } else {
    next(getRegistrationRedirect(user) || { name: 'Dashboard' })
  }
}

const destinationRedirectIfExists = (to, from, next) => {
  if (
    store.state?.completeRegistration?.destination === CompleteRegistrationDestinationType.STUDY &&
    store.state?.completeRegistration?.studyId
  ) {
    next(`/study/${store.state.completeRegistration.studyId}`)
  } else if (
    store.state?.completeRegistration?.destination === CompleteRegistrationDestinationType.CHAT &&
    store.state?.completeRegistration?.chatId
  ) {
    next(`/chats/${store.state.completeRegistration.chatId}`)
  } else {
    next()
  }
}

const test = (to, from, next) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('resolve')
      resolve(next())
    }, 1000)
  })
}

export default {
  isAuthorized,
  destinationRedirectIfExists,
  registrationRequired,
  registrationNotRequired,
  registrationDetailsRequired,
  test
}
